import {
  IconArrowDownOutline,
  IconArrowLeftOutline,
  IconArrowRightOutline,
  IconArrowUpOutline,
  IconMinusOutline,
  IconPlusOutline,
} from '@/components/icons'
import { Button } from '@/components/shadcn/button'

type Handlers = {
  incrVerticalTop: () => void
  moveUp: () => void
  decrVerticalTop: () => void
  decrHorizontalRight: () => void
  moveRight: () => void
  incrHorizontalRight: () => void
  incrVerticalBottom: () => void
  moveDown: () => void
  decrVerticalBottom: () => void
  decrHorizontalLeft: () => void
  moveLeft: () => void
  incrHorizontalLeft: () => void
}

export function LayoutButtons({ handlers }: { handlers: Handlers }) {
  return (
    <>
      <div className="absolute -top-3 flex w-full justify-center gap-2 text-grey-medium">
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.decrVerticalTop}
        >
          <IconMinusOutline className="size-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.moveUp}
        >
          <IconArrowUpOutline className="size-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.incrVerticalTop}
        >
          <IconPlusOutline className="size-4" />
        </Button>
      </div>
      <div className="absolute -right-3 top-1/2 z-10 flex -translate-y-1/2 flex-col gap-2">
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.decrHorizontalRight}
        >
          <IconMinusOutline className="size-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.moveRight}
        >
          <IconArrowRightOutline className="size-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.incrHorizontalRight}
        >
          <IconPlusOutline className="size-4" />
        </Button>
      </div>
      <div className="absolute -bottom-3 left-1/2 z-10 flex -translate-x-1/2 gap-2">
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.decrVerticalBottom}
        >
          <IconMinusOutline className="size-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.moveDown}
        >
          <IconArrowDownOutline className="size-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.incrVerticalBottom}
        >
          <IconPlusOutline className="size-4" />
        </Button>
      </div>
      <div className="absolute -left-3 top-1/2 flex -translate-y-1/2 flex-col gap-2">
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.decrHorizontalLeft}
        >
          <IconMinusOutline className="size-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.moveLeft}
        >
          <IconArrowLeftOutline className="size-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="size-6 rounded-full border border-grey-lighterer"
          onClick={handlers.incrHorizontalLeft}
        >
          <IconPlusOutline className="size-4" />
        </Button>
      </div>
    </>
  )
}
